/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/**
 * Sends a custom analytics event, the non-page-view sibling of
 * {@link import('./send-page-view').sendPageView}.
 *
 * Silent when GTM never loaded -- the container is absent in local builds and
 * whenever the visitor declined analytics cookies, and an event is never worth
 * a crash.
 *
 * @param name - The event name, snake_case, e.g. `spreadsheet_export`.
 * @param params - Event parameters, already flat.
 */
export function sendEvent(name: string, params: Record<string, unknown> = {}): void {
  const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
  if (!gtag) return;
  gtag('event', name, params);
}
